import React, { useState,useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Checkbox, Button, Input, Form, Select, Upload, App,Modal } from 'antd';
import type { UploadProps, UploadFile, GetProp } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import styles from './StoreEntryStep1.module.scss';
import { IFormDataAll } from '../../types';
import CookieUtil from '@/utils/cookies';
import { getProductCategoryAllList, getProductBrandAllList } from '@/api/products';
import { useAppSelector } from '@/store/hooks';
import { useTranslation } from 'react-i18next';

//文件类型
type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];
interface StoreEntryStep1Props {
  onNext?: (submitData: any) => void;
  onCancel?: () => void;
  getStoreType?: (type: 'individual' | 'business') => void;
  formData?: IFormDataAll;
}

// 店铺入驻第一步
const StoreEntryStep1: React.FC<StoreEntryStep1Props> = ({
  onNext,
  onCancel,
  getStoreType,
  formData
}) => {
  const [storeType, setStoreType] = useState<'individual' | 'business'>('individual');
  const [form] = Form.useForm();
  const [agreementChecked, setAgreementChecked] = useState(false);
  const [authorizationChecked, setAuthorizationChecked] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
      //国际化语言切换
  const { t, i18n } = useTranslation();

  // 上传配置

  //message弹窗对象
  const { message } = App.useApp();
 //获取token
 const token = useAppSelector((state) => state.user.token);
 const [fileList, setFileList] = useState<any[]>([]);

   // 添加预览状态变量 附件查看大图配置
   const [previewVisible, setPreviewVisible] = useState(false);
   const [previewImage, setPreviewImage] = useState('');
   const [previewTitle, setPreviewTitle] = useState('');
   // 添加预览状态变量 附件查看大图配置
 
   //图片上传配置
   const uploadProps: UploadProps = {
     name: 'file',
     action: `${process.env.REACT_APP_API_URL}/api/product/save_upload_file`,
     accept: ".png,.jpeg,.jpg,.gif",
     headers: {
       //记得修改
       token: `${token}`,
     },
     listType: 'picture-card',
     maxCount: 1, // 只允许上传五个
     showUploadList: true, // 显示fileList
     fileList: fileList,
     beforeUpload: (file) => {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        message.error(t('storeEntry.Image10MB'));
      }
      return isLt10M; // 返回 false 阻止上传
    },
     onChange(info) {
       //debugger
       // 复制一份文件列表
       const newFileList = [...info.fileList];
 
       // 对文件状态进行处理
       newFileList.forEach(file => {
         if (file.response) {
           // 可以从响应中获取文件URL
           file.url = file?.response?.data?.url;
         }
       });
 
       // 更新状态
       setFileList(newFileList);
 
       if (info.file.status !== 'uploading') {
         console.log(info.file, info.fileList);
       }
 
       if (info.file.status === 'done') {
         //完成逻辑
         // setFileList([...fileList, info.file]);
 
       } else if (info.file.status === 'removed') {
         //删除逻辑
         
         setFileList([...info.fileList]);
 
       } else if (info.file.status === 'error') {

         message.error(`${info.file.name} file upload failed.`);

       }
     },
     async onPreview(file: UploadFile) {
       //预览逻辑
       let src = file.url as string;
       if (!src) {
         src = await new Promise((resolve) => {
           const reader = new FileReader();
           reader.readAsDataURL(file.originFileObj as FileType);
           reader.onload = () => resolve(reader.result as string);
         });
       }
       // 设置预览状态
       setPreviewImage(src);
       setPreviewVisible(true);
       setPreviewTitle(file.name || '图片预览');
     }
   };
 
   //Main Image图片上传配置 Main Image图片上传配置

  // 处理提交
  const handleSubmit = () => {
    // const token = CookieUtil.get('token');
    // if (!token) {
    //   const currentPath = location.pathname + location.search;
    //   navigate(`/login?redirect=${encodeURIComponent(currentPath)}`);
    //   return;
    // }

    if (fileList.length === 0) {
      message.error(t('storeEntry.Pleaseuploadatleastoneimage'));
      return;
    }

    form.validateFields().then(values => {
      
      const submitData = {
        ...values,
        merchant_type: storeType === 'individual' ? 1 : 2,
        store_logo:fileList.map(file => ({
          uid: file.uid,
	      url:	file.url,
        }))
      }
      console.log('StoreEntryStep1 - Form values:', values);
      console.log('StoreEntryStep1 - submitData:', submitData);
      console.log('StoreEntryStep1 - primary_category:', submitData.primary_category, typeof submitData.primary_category);
      console.log('StoreEntryStep1 - categoryList:', categoryList);
      onNext && onNext(submitData);
    }).catch(err => {
      console.error('Validation failed:', err);
    });
  };


  // 初始化表单数据 编辑回传
  useEffect(() => {
    // 如果有formData，则填充表单
    if (formData) {
      // 解析手机号码
      // let phoneCountryCode = '+1';
      // let phoneNumber = '';
      
      // if ((formData as any).support_phone) {
      //   // 如果support_phone包含国家代码，解析它
      //   if ((formData as any).support_phone.startsWith('+1')) {
      //     phoneCountryCode = '+1';
      //     phoneNumber = (formData as any).support_phone.substring(2);
      //   } else if ((formData as any).support_phone.startsWith('+86')) {
      //     phoneCountryCode = '+86';
      //     phoneNumber = (formData as any).support_phone.substring(3);
      //   } else if ((formData as any).support_phone.startsWith('+44')) {
      //     phoneCountryCode = '+44';
      //     phoneNumber = (formData as any).support_phone.substring(3);
      //   } else {
      //     phoneNumber = (formData as any).support_phone;
      //   }
      // }

      console.log('formData:', formData);
      
      // 使用 setTimeout 确保表单完全初始化后再设置值
      setTimeout(() => {
        // 完全恢复用户之前的状态，包括空值状态
        form.setFieldsValue(formData);
        // 强制更新表单验证状态，确保UI与数据同步
        form.validateFields();
      }, 100);
  
      setStoreType(formData.merchant_type === 1 ? 'individual' : 'business');
      setAgreementChecked(true);
      setAuthorizationChecked(true);
      
      // 处理文件上传回填
      if (formData.store_logo && formData.store_logo.length > 0) {
        const images = formData.store_logo.map((item:any, index:number) => ({
          uid: item.uid,
          file_id:item.uid || null,
          name: `image-${index}.png`,
          status: 'done' as const,
          url: item.url,
        })) as any[];
        console.log('images',images);
        
        setFileList(images);
      }
      
    }
  }, [formData]);


  const setStoreTypeAction = (type: 'individual' | 'business') => {
    setStoreType(type);
    if (getStoreType) {
      getStoreType(type);
    }
  }

  const [categoryList, setCategoryList] = useState<any[]>([]);

  useEffect(() => {
    getProductCategoryAllList().then((res) => {
      console.log(res, 'getProductCategoryAllList');
      if(res.code === 200){
        setCategoryList(res.data || []);
      } else {
        console.error('Failed to load category list:', res);
        message.error('加载分类列表失败，请刷新页面重试');
      }
    }).catch((error) => {
      console.error('Category list API error:', error);
      message.error('加载分类列表失败，请检查网络连接');
    });
  }, []);

  return (
    <div className={styles['store-entry-step1']}>
      <div className={styles['header']}>
        <div className={styles['header-title']}>{t('storeEntry.StoreInformation')}</div>
        <div className={styles['header-protection']}>
          <span className={styles['protection-icon']}>✓</span>
          {t('storeEntry.YourInformation')}
        </div>
      </div>

      <Form 
        form={form} 
        layout="vertical"
        initialValues={{
          store_description: (formData as any)?.store_description || '',
          merchant_name: formData?.merchant_name || '',
          store_url_slug: (formData as any)?.store_url_slug || '',
          primary_category: (formData as any)?.primary_category || undefined,
          email: (formData as any)?.email || '',
          return_policy_summary: (formData as any)?.return_policy_summary || '',
        }}
      >
        {/* 店铺类型选择 */}
        <div className={styles['section']}>
          <div className={styles['section-title']}>{t('storeEntry.StoreType')}</div>
          <div className={styles['store-type-container']}>
            <div
              className={`${styles['store-type-option']} ${storeType === 'individual' ? styles['selected'] : ''}`}
              onClick={() => setStoreTypeAction('individual')}
            >
              <div className={styles['option-title']}>{t('storeEntry.Individual')}</div>
              <div className={styles['option-details']}>
                <div>{t('storeEntry.Legalfirst')}</div>
                <div>{t('storeEntry.SSN/ITINlast4digits')}</div>
                <div>{t('storeEntry.GovernmentIDtype&token')}</div>
                <div>{t('storeEntry.Taxformselection')}</div>
              </div>
            </div>
            <div
              className={`${styles['store-type-option']} ${storeType === 'business' ? styles['selected'] : ''}`}
              onClick={() => setStoreTypeAction('business')}
            >
              <div className={styles['option-title']}>{t('storeEntry.Company')}</div>
              <div className={styles['option-details']}>
                <div>{t('storeEntry.Companylegalname')}</div>
                <div>{t('storeEntry.EIN')}</div>
                <div>{t('storeEntry.Taxsettings')}</div>
                <div>{t('storeEntry.CertificateofInsurance')}</div>
              </div>
            </div>
          </div>
        </div>

        {/* 店铺基本信息 */}
        <div className={styles['section']}>
          <Form.Item
            name="merchant_name"
            label={<span className={styles['required-label']}>{t('storeEntry.StoreName')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleasename') }]}
          >
            <Input 
              placeholder={t('storeEntry.ItCanBeModifiedAfterOpeningTheStore')} 
              maxLength={30}
              suffix={<span className={styles['char-count']}>0/30</span>}
            />
          </Form.Item>

          <Form.Item
            name="store_url_slug"
            label={<span className={styles['required-label']}>{t('storeEntry.StoreURLSlug')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleaseenterstoreurlslug') }]}
          >
            <Input placeholder={t('storeEntry.ItCanBeModifiedAfterOpeningTheStore')} />
          </Form.Item>

          <Form.Item
            name="primary_category"
            label={<span className={styles['required-label']}>{t('storeEntry.PrimaryCategory')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleasechooseprimarycategory') }]}
          >
            <Select placeholder={t('storeEntry.FarmProduce')}>
            {
              categoryList && categoryList.map((item) => {
              return (
                <Select.Option key={item.product_category_id} value={item.product_category_id}>{item.product_category_name}</Select.Option>
              )
              })
            }
            </Select>
          </Form.Item>

          <Form.Item
            name="store_logo"
            label={<span className={styles['required-label']}>{t('storeEntry.StoreLogo')}</span>}
          >
            <Upload {...uploadProps}>
              {t('storeEntry.Upload')}
            </Upload>
          </Form.Item>

          <Form.Item
            name="store_description"
            label={<span className={styles['required-label']}>{t('storeEntry.StoreDescription')}</span>}
            rules={[{ required: true, message: t('storeEntry.Pleaseenterstoredescription') }]}
          >
            <div className={styles['textarea-wrapper']}>
              <Input.TextArea 
                placeholder={t('storeEntry.ItModifiedAfterOpeningStore')} 
                autoSize={{ minRows: 3, maxRows: 6 }}
                maxLength={60}
                defaultValue={(formData as any)?.store_description || ''}
              />
              <span className={styles['char-count']}>0/60</span>
            </div>
          </Form.Item>

          <Form.Item
            name="email"
            label={<span className={styles['required-label']}>{t('storeEntry.SupportEmail')}</span>}
            rules={[
              { required: true, message: t('storeEntry.PleaseEnterSupportEmail') },
              { type: 'email', message: t('storeEntry.PleaseenterEmail') }
            ]}
          >
            <Input placeholder={t('storeEntry.Email')} />
          </Form.Item>

          {/* <Form.Item
            label={<span className={styles['required-label']}>Support Phone</span>}
          >
            <Input.Group compact>
              <Form.Item
                name="phone_code"
                noStyle
                initialValue="+1"
              >
                <Select style={{ width: '80px' }}>
                  <Select.Option value="+1">+1</Select.Option>
                  <Select.Option value="+86">+86</Select.Option>
                  <Select.Option value="+44">+44</Select.Option>
                </Select>
              </Form.Item>
              
            </Input.Group>
          </Form.Item> */}


          <Form.Item
            name="phone"
            label={<span className={styles['required-label']}>{t('storeEntry.SupportPhone')}</span>}
            rules={[
              { required: true, message: t('storeEntry.enterphonenumber') },
             
            ]}
          >
            <Input placeholder={t('storeEntry.Phone')} />
          </Form.Item>

        
          <Form.Item
            name="return_policy_summary"
            label={<span className={styles['required-label']}>{t('storeEntry.PolicySummary')}</span>}
            rules={[{ required: true, message: t('storeEntry.enterreturnpolicy') }]}
          >
            <Input placeholder={t('storeEntry.7-DayReturnsAccepted')} />
          </Form.Item>
        </div>

        {/* 协议同意 */}
        <div className={styles['section']}>
          <div className={styles['agreement-item']}>
            <Checkbox
              checked={agreementChecked}
              onChange={(e) => setAgreementChecked(e.target.checked)}
              className={styles['agreement-checkbox']}
            />
            <div className={styles['agreement-text']}>
              {t('storeEntry.Ihavereadandagreetothefollowingagreements')} <a className={styles['agreement-link']}>{t('storeEntry.theConsumerProtectionServiceAgreement')}</a> {t('common.andThe')} <a className={styles['agreement-link']}>{t('storeEntry.theSellerServiceAgreement')}</a>.
            </div>
          </div>

          <div className={styles['agreement-item']}>
            <Checkbox
              checked={authorizationChecked}
              onChange={(e) => setAuthorizationChecked(e.target.checked)}
              className={styles['agreement-checkbox']}
            />
            <div className={styles['agreement-text']}>
              {t('storeEntry.IagreetoallowTownLoop')} <a className={styles['agreement-link']}>{t('storeEntry.TownloopStoreOpeningAuthenticationAuthorizationInstructions')}</a>.
            </div>
          </div>
        </div>

        {/* 按钮区域 */}
        <div className={styles['button-container']}>
          <Button
            type="primary"
            className={styles['submit-button']}
            onClick={handleSubmit}
            disabled={!agreementChecked || !authorizationChecked}
          >
            {t('storeEntry.Next')}
          </Button>
        </div>
      </Form>

      {/* 添加预览Modal */}
      <Modal
        open={previewVisible}
        title={previewTitle}
        width={"80%"}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt={previewTitle} style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </div>
  );
};

export default StoreEntryStep1; 